<template>
  <div class="app-calendar border">
    <div class="row no-gutters">
      <!-- Sidebar -->
      <div class="col app-calendar-sidebar flex-grow-0 d-flex flex-column"
           :class="{ 'show': isCalendarOverlaySidebarActive }"
      >
        <calendar-sidebar
          ref="refSidebar"
          :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive"
          @sidebar-active="isCalendarOverlaySidebarActive = false"
        />
      </div>

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0 ">
          <div class="card-body pb-0">
            <div class="body-content-overlay"
                 :class="{ 'show': isEventHandlerSidebarActive }"
                 @click="isEventHandlerSidebarActive = false"
            />
            <button class="btn btn-primary btn-block btn-mobile" @click="isEventHandlerSidebarActive = true">
              +
            </button>
            <full-calendar ref="refCalendar" :options="calendarOptions" class="full-calendar" />
          </div>
        </div>
      </div>

      <div class="body-content-overlay"
           :class="{ 'show': isCalendarOverlaySidebarActive }"
           @click="isCalendarOverlaySidebarActive = false"
      />
      <calendar-event-handler :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" :event="event"
                              :clear-event-data="clearEventData" @remove-event="removeEvent" @add-event="addEvent"
                              @update-event="updateEvent" />
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import CalendarSidebar from './CalendarSidebar.vue'
import CalendarEventHandler from './calendar-event-handler/CalendarEventHandler.vue'

// eslint-disable-next-line import/no-cycle
import useCalendar from './useCalendar'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    CalendarEventHandler,
  },
  setup() {
    const {
      refCalendar,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      handleDateSelect,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isCalendarOverlaySidebarActive,
    } = useCalendar()

  return {
      refCalendar,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      handleDateSelect,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isCalendarOverlaySidebarActive,
  }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
@import '@core/scss/base/core/colors/palette-variables';

.fc-event,
.fc-event:hover {
  background-color: #3788d8;
}

.fc-event-title,
.fc-event-time {
  color: $white;
}

.fc-scrollgrid-section-header {
  overflow: visible;
  position: sticky;
  top: 62px;
  z-index: 2;
}

.dark-layout {
  .fc-col-header-cell {
    background: $theme-dark-card-bg;
  }
}

// Masquer les éléments par défaut de FullCalendar quand on a des avatars
.fc-event:has(.calendar-event-content) {
  .fc-event-title:not(.calendar-event-title),
  .fc-event-time:not(.calendar-event-time) {
    display: none !important;
  }
}

// Fallback pour les navigateurs qui ne supportent pas :has()
.fc-event .fc-event-main:has(.calendar-event-content) {
  .fc-event-title:not(.calendar-event-title),
  .fc-event-time:not(.calendar-event-time) {
    display: none !important;
  }
}

// Styles pour les événements avec avatars
    .calendar-event-content {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
        padding: 0.25rem;
        width: 100%;
        min-height: 2rem;
        overflow: hidden;
    }

.calendar-event-avatar-container {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.calendar-event-info {
  flex: 1;
  min-width: 0; /* allow text ellipsis in flex */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* left align content inside */
}

.calendar-event-time {
  font-size: 0.68rem;
  line-height: 1.1;
  color: rgba(255, 255, 255, 0.85) !important;
  margin-bottom: 0.1rem;
}

.calendar-event-title {
  font-size: 0.8rem;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: $white !important;
  font-weight: 500;
}

@media (max-width: 767.98px) {
  .calendar-event-content {
    gap: 0.25rem;
    padding: 0.2rem;
    min-height: 1.8rem;
  }

  .calendar-event-time {
    font-size: 0.6rem;
  }

  .calendar-event-title {
    font-size: 0.7rem;
  }
}

.fc-event {
  .initials-avatar {
    .b-avatar {
      width: 1.5rem !important;
      height: 1.5rem !important;
      font-size: 0.7rem !important;
    }
  }
}

@media (max-width: 767.98px) {
  .fc-event {
    .initials-avatar {
      .b-avatar {
        width: 1.2rem !important;
        height: 1.2rem !important;
        font-size: 0.6rem !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.btn-mobile {
  display: none;
}

@media (max-width: 767.98px) {
  .btn-mobile {
    position: absolute;
    width: 4rem;
    height: auto;
    right: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }
}
</style>
